import { Typography } from 'antd';
import {
  formSectionAccentBarStyle,
  formSectionDividerStyle,
  formSectionHeaderStyle,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/components/MaintenanceSlaContractForm/MaintenanceSlaContractForm.style';

export function FormSectionHeader({
  color,
  label,
  first = false,
}: {
  color: string;
  label: string;
  first?: boolean;
}) {
  return (
    <div
      style={{
        ...formSectionHeaderStyle,
        marginTop: first ? 0 : formSectionHeaderStyle.marginTop,
      }}
    >
      <div style={{ ...formSectionAccentBarStyle, backgroundColor: color }} />
      <Typography.Text className="ds-section-header">{label}</Typography.Text>
      <div style={formSectionDividerStyle} />
    </div>
  );
}
